
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/wallet",
      function () {
        return require("private-next-pages/en/wallet/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/wallet"])
      });
    }
  